import { PageStyle, ModalStyle, ButtonStyle, Button, ClientDashboard, Checkbox, Form, Formik, FormikControl, Image, useEffect, useRouter, useState, clearSWRCache, SelectJobModalAction, ErrorPages, useSWR, CONSTANTS, Loading, InputError, useRef, components, Tooltip, Field } from '@/imports-files/components/model/select-job-modal';

export function SocialLinkModal({formRef, socialPopup, setSocialPopup, customizeCareerAction})
{
  const formik =  socialPopup.formik
  const [facebookLink, setFacebookLink] = useState(formRef.current.values.page_sections_attributes[socialPopup.index].career_team_section_attributes.career_team_details_attributes[socialPopup.team_index].facebook_url)
  const [twitterLink, setTwitterLink] = useState(formRef.current.values.page_sections_attributes[socialPopup.index].career_team_section_attributes.career_team_details_attributes[socialPopup.team_index].twitter_url)
  const [linkedinLink, setLinkedinLink] = useState(formRef.current.values.page_sections_attributes[socialPopup.index].career_team_section_attributes.career_team_details_attributes[socialPopup.team_index].linkedin_url)
  return socialPopup.state ? (
    <>
      <div className={`${PageStyle.SetupPopup} ${PageStyle.SelectJob} ${ModalStyle.SelectJob}`}>
        <div className={`${PageStyle.SetupPopup__inner} ${ModalStyle.SetupPopup__ModalCenter}`}>
         <div className={`${ModalStyle.SetupPopup__ModalContent}`}>
          <div className={`${PageStyle.OtpBacksection} ${ModalStyle.OtpBacksection}`}>
            <div className={`${PageStyle.Otpback} ${ModalStyle.Otpback}`}>
              <Button buttonstyle={ButtonStyle.nobgbutton} type="button" onClick={()=> setSocialPopup({state: false})}>Close</Button>
            </div>
          </div>
          <div className={`PhoneSetupPage SetupPage ${PageStyle.SetupPopup__Content} ${ModalStyle.SetupPopup__Content} DisplayInline ${PageStyle.mt15}`}>
            <h1>Add social link</h1>
          </div>

          <div className={`${PageStyle.SelectJob__Content} ${ModalStyle.SelectJob__Content}`}>
            <label>Facebook Link</label>
          </div>

          <div className={`${PageStyle.SelectJob__Content} ${ModalStyle.SelectJob__Content}`}>
            <div className={PageStyle.SelectJob__CustomSelectWidth}>
              <input
                className={`${PageStyle.Form__Input} thresholdmodl`}
                type="text"
                value={facebookLink}
                defaultValue={''}
                onChange={(event) => {
                  setFacebookLink(event.target.value)
                }}
              />
            </div>
          </div>

          <div className={`${PageStyle.SelectJob__Content} ${ModalStyle.SelectJob__Content}`}>
            <label>Twitter Link</label>
          </div>

          <div className={`${PageStyle.SelectJob__Content} ${ModalStyle.SelectJob__Content}`}>
            <div className={PageStyle.SelectJob__CustomSelectWidth}>
              <input
                className={`${PageStyle.Form__Input} thresholdmodl`}
                type="text"
                value={twitterLink}
                defaultValue={''}
                onChange={(event) => {
                  setTwitterLink(event.target.value)
                }}
              />
            </div>
          </div>

          <div className={`${PageStyle.SelectJob__Content} ${ModalStyle.SelectJob__Content}`}>
            <label>Linkedin Link</label>
          </div>

          <div className={`${PageStyle.SelectJob__Content} ${ModalStyle.SelectJob__Content}`}>
            <div className={PageStyle.SelectJob__CustomSelectWidth}>
              <input
                className={`${PageStyle.Form__Input} thresholdmodl`}
                type="text"
                value={linkedinLink}
                defaultValue={''}
                onChange={(event) => {
                  setLinkedinLink(event.target.value)
                }}
              />
            </div>
          </div>

          <div className={`${PageStyle.SelectJob__Footer} ${ModalStyle.SelectJob__Footer}`}>
            <div className={`${PageStyle.SelectJob__ButtonAction} ${ModalStyle.SelectJob__ButtonAction}`}>
              <Button buttonstyle={PageStyle.primarybtn} type="button" onClick={async() => {
                await formRef.current.setFieldValue(`page_sections_attributes.${socialPopup.index}.career_team_section_attributes.career_team_details_attributes.${socialPopup.team_index}.facebook_url`, facebookLink)
                await formRef.current.setFieldValue(`page_sections_attributes.${socialPopup.index}.career_team_section_attributes.career_team_details_attributes.${socialPopup.team_index}.twitter_url`, twitterLink)
                await formRef.current.setFieldValue(`page_sections_attributes.${socialPopup.index}.career_team_section_attributes.career_team_details_attributes.${socialPopup.team_index}.linkedin_url`, linkedinLink)
                setTimeout(await customizeCareerAction.updateAboutRef(socialPopup.index), 100)
                setSocialPopup({state: false})
              }}>
              Save
              </Button>
            </div>
          </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    ""
  );
}